<template>
  <transition name='fade'>
    <div v-if='editingAddress'>
      <div class="header-section">

        <SfHeading :level="5" :title="isNewAddress ? $t('Add new address') : $t('Update address')"
                   class="sf-heading--left"/>
        <SfButton class="return" @click="editingAddress=false">
          {{ $t('Back') }}
        </SfButton>
      </div>
      <AddressForm :address="activeAddress" :is-new="isNewAddress" :is-shipping="false" @submit="submitAddress"/>

    </div>

    <div v-else>
      <div class="header-section">
        <SfHeading :level="5" :title="$t('Manage addresses')" class="sf-heading--left"/>
      </div>
      <transition-group appear class='shipping-list' name='fade' tag='div'>

        <div v-for='address in customer.addresses' :key='address.name' class='shipping'>

          <div class='shipping__address'>
            <UserAddress :address='address'/>
            <div class='form__default__address'>
              <OrkToggle

                  :description="$t('Default shipping address')"
                  :selected="defaultShippingAddress===address.name"
                  class='form__toggle'
                  name='shipping'
                  size="medium"
                  @change="changeDefaultShippingAddress($event,address)"></OrkToggle>

              <OrkToggle
                  :description="$t('Default billing address')"
                  :selected="defaultBillingAddress===address.name"
                  class='form__toggle'
                  name='billing'
                  size="medium"
                  @change="changeDefaultBillingAddress($event,address)"></OrkToggle>

            </div>
            <div class='shipping__actions'>
              <SfButton @click='changeAddress(address)'>
                {{ $t('Edit') }}
              </SfButton>
              <SfButton
                  class='sf-button--outline'
                  @click='removeAddress(address.name)'
              >
                {{ $t('Delete') }}
              </SfButton>
            </div>

          </div>
        </div>
      </transition-group>
      <SfButton class='color-secondary action-button' @click='changeAddress(null)'>
        {{ $t('Add new address') }}
      </SfButton>

    </div>
  </transition>
</template>

<script>

import {SfButton, SfHeading} from '@storefront-ui/vue';
import UserAddress from '@/components/UserAddress';
import AddressForm from '@/components/MyAccount/AddressForm';
import Api from "@/api/Api";
import icons from "@/utils/icons";
import OrkToggle from "@/components/Ork/OrkToggle";

export default {
  name: 'Addresses',

  components: {
    OrkToggle,
    SfHeading,
    SfButton,
    UserAddress,
    AddressForm
  },
  data() {
    return {
      defaultShippingAddress: null,
      defaultBillingAddress: null,
      activeAddress: null,
      isNewAddress: false,
      editingAddress: false
    }
  },
  computed: {
    customer: {
      get() {
        return this.$store.getters.getProfile
      },
      set() {

      }
    },
    currentCart: {
      get() {
        return this.$store.getters.getCart;
      },
    }
  },
  mounted() {
    this.defaultShippingAddress = this.customer.defaultShippingAddress;
    this.defaultBillingAddress = this.customer.defaultBillingAddress
  },
  watch: {
    customer(customer) {

      this.defaultShippingAddress = customer.defaultShippingAddress;
      this.defaultBillingAddress = customer.defaultBillingAddress
    }
  },
  methods: {
    removeAddress(addressName) {
      Api.account.removeAddress(addressName).then(
          () => {
            this.customer = this.$store.dispatch('removeCustomerAddress', addressName);
            this.$store.dispatch('sendNotification', {
              type: 'info',
              message: this.$i18n.t('address.removed'),
              icon: icons.check
            });
          })
          .catch((e) => {
            let error = '';
            switch (e.status) {
              case 401:
                error = this.$i18n.t('errors.address.unauthorized')
                break;
              case 409:
                error = this.$i18n.t('errors.address.allReadyExist')
                break;
              case 404:
                error = this.$i18n.t('errors.address.notFound')
                break;
              case 500:
                error = this.$i18n.t('errors.server.access')
                break;
            }
            this.$store.dispatch('sendNotification', {type: 'danger', message: error, icon: icons.error});
          })
    },

    checkIsDefault(address) {
      let defaultBilling = false;
      let defaultShipping = false;

      if (this.customer.defaultBillingAddress === address.name) {
        defaultBilling = true;
      }

      if (this.customer.defaultShippingAddress === address.name) {
        defaultShipping = true;
      }

      return {defaultShipping, defaultBilling};
    },

    changeAddress(address) {
      if (address) {
        this.isNewAddress = false;
        this.activeAddress = {...address, ...this.checkIsDefault(address)};

      } else {
        this.isNewAddress = true;
        this.activeAddress = undefined;
      }

      this.editingAddress = true;
    },

    submitAddress({address, onComplete, onError}) {

      Api.account.addAddress(address)
          .then((data) => {
            this.$store.dispatch('addCustomerAddress', {isNew: this.isNewAddress, address});
            onComplete(data);
            this.editingAddress = false
            if (this.isNewAddress) {
              this.$store.dispatch('sendNotification', {
                type: 'info',
                message: this.$i18n.t('address.created'),
                icon: icons.check
              });
            } else {
              this.$store.dispatch('sendNotification', {
                type: 'info',
                message: this.$i18n.t('address.updated'),
                icon: icons.check
              });
            }
          })
          .catch((e) => {
            console.error(e)
            let error = '';
            switch (e.status) {
              case 401:
                error = this.$i18n.t('errors.address.unauthorized')
                break;
              case 409:
                error = this.$i18n.t('errors.address.allReadyExist')
                break;
              case 404:
                error = this.$i18n.t('errors.address.notFound')
                break;
              case 500:
                error = this.$i18n.t('errors.server.access')
                break;
            }
            this.$store.dispatch('sendNotification', {type: 'danger', message: error, icon: icons.error});
            onError(error)
          })
    },
    changeDefaultShippingAddress(isSelected, address) {
      let changedAddress = {...address}
      changedAddress.defaultShipping = isSelected
      changedAddress.defaultBilling = this.defaultBillingAddress === changedAddress.name

      Api.account.addAddress(changedAddress)
          .then(() => {
            this.$store.dispatch('addCustomerAddress', {isNew: false, address: changedAddress});

            this.$store.dispatch('sendNotification', {
              type: 'info',
              message: this.$i18n.t('address.shipping'),
              icon: icons.check
            });

          })
          .catch((e) => {
            console.error(e)
            let error = '';
            switch (e.status) {
              case 401:
                error = this.$i18n.t('errors.address.unauthorized')
                break;
              case 409:
                error = this.$i18n.t('errors.address.allReadyExist')
                break;
              case 404:
                error = this.$i18n.t('errors.address.notFound')
                break;
              case 500:
                error = this.$i18n.t('errors.server.access')
                break;
            }
            this.$store.dispatch('sendNotification', {type: 'danger', message: error, icon: icons.error});

          })
    },


    changeDefaultBillingAddress(isSelected, address) {
      let changedAddress = {...address}

      changedAddress.defaultBilling = isSelected
      changedAddress.defaultShipping = this.defaultShippingAddress === changedAddress.name

      Api.account.addAddress(changedAddress)
          .then(() => {
            this.$store.dispatch('addCustomerAddress', {isNew: false, address: changedAddress});

            this.$store.dispatch('sendNotification', {
              type: 'info',
              message: this.$i18n.t('address.billing'),
              icon: icons.check
            });

          })
          .catch((e) => {
            console.error(e)
            let error = '';
            switch (e.status) {
              case 401:
                error = this.$i18n.t('errors.address.unauthorized')
                break;
              case 409:
                error = this.$i18n.t('errors.address.allReadyExist')
                break;
              case 404:
                error = this.$i18n.t('errors.address.notFound')
                break;
              case 500:
                error = this.$i18n.t('errors.server.access')
                break;
            }
            this.$store.dispatch('sendNotification', {type: 'danger', message: error, icon: icons.error});

          })
    }
  }
}
</script>

<style lang="scss" scoped>

.shipping__address {
  margin: var(--spacer-base) 0;
  border: 1px solid var(--_c-primary-background);
  box-shadow: 0 2px 5px -2px rgba(0, 0, 0, 0);

  ::v-deep {
    .user-address {
      padding: var(--spacer-base);
      border: none;
      box-shadow: none;
    }
  }
}

.header-section {
  min-height: 40px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: space-between;
  margin: var(--spacer-base) 0;
  padding: 0 0 var(--spacer-xs) 0;
  border-bottom: 3px solid var(--_c-primary-background);

  ::v-deep {
    .sf-heading {
      padding-bottom: 0;

      &__title {
        font-weight: bold;
      }
    }
  }
}

.sf-button.return {

  min-height: 32px;
  padding: var(--spacer-xs) var(--spacer-sm);
  background-color: var(--c-tertiary);
}

.shipping__actions {
  display: flex;
  margin: var(--spacer-xs) var(--spacer-base);

  .sf-button {
    margin: var(--spacer-xs) 0;
    flex: 1;
    min-height: 42px;
    padding: var(--spacer-xs) var(--spacer-sm);

    &:first-of-type:not(:last-of-type) {
      margin: var(--spacer-sm) var(--spacer-sm) var(--spacer-sm) 0;
    }

    &:last-of-type:not(:first-of-type) {
      margin: var(--spacer-sm) 0 var(--spacer-sm) var(--spacer-sm);
    }
  }
}

.form__default__address {
  display: flex;
  flex-wrap: wrap;
  gap: var(--spacer-base);
  padding: var(--spacer-sm);
  margin: var(--spacer-base);
  background-color: var(--_c-primary-sidebar);

  .form__toggle {
    flex: 1;
    @include for-mobile {
      flex: 100%;
    }
  }
}

.shipping-list {
  width: 100%;
  flex-wrap: wrap;
  display: inline-grid;
  gap: 20px;
  grid-template-columns:  repeat(2, 1fr);
  @include for-desktop-small {
    grid-template-columns:  repeat(1, 1fr);
  }
  @include for-tablet {
    grid-template-columns:  repeat(2, 1fr);
  }
  @include for-mobile {
    grid-template-columns:  repeat(1, 1fr);
  }


  .shipping {
    flex: 1;
    display: flex;
    flex-wrap: wrap;
    align-self: stretch;

    &__address {
      display: flex;
      flex-direction: column;
      flex: 1;

      .form__default__address {
        margin-top: auto;
        flex-wrap: wrap;

        .form__toggle {
          flex: auto;
        }
      }
    }
  }
}

.action-button {
  margin: var(--spacer-base) auto 0;
}
</style>
